export default __webpack_public_path__ + "static/media/category_program.335811d4.svg";